import moment from 'moment';
import '../common/bn-property';
import '../common/bn-loading';
import './add-new-import-modal';
import { entityStore } from '~/utility/BinSentry-ui-utility';
import { css, html, LitEntity, renderIf } from '../utility/lit-entity';
import { sharedStyles } from '../styles/shared-styles';
import { bannerStyles } from '../styles/banner-styles';
import '../common/bn-load-more-button';

class ImportList extends LitEntity {
  static get properties() {
    return {
      showModal: { type: Boolean, attribute: false },
      imports: { type: Array, attribute: false },
      title: { type: String },
      description: { type: String },
      importShowPath: { type: String, attribute: 'import-show-path' },
    };
  }

  static get styles() {
    return [sharedStyles, bannerStyles, css`
      .title-container {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        flex-shrink: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        flex-wrap: wrap;
        margin: 0 var(--root-margin);
      }
      .title-container h1 {
        margin-left: 0;
        margin-bottom: 0.5em;
      }
      .description {
        margin: 0 var(--root-margin);
      }
      .properties {
        display: flex;
        flex-wrap: wrap;
      }
      bn-property {
        margin: 0 2em 0 0;
      }
      .no-data {
        margin: 2em 0.5em;
        text-align: center;
      }
      .name-property {
        min-width: 12em;
      }
      .state-property {
        min-width: 7em;
      }
      @media(max-width: 1100px) {
        .properties {
          flex-direction: column;
        }
        bn-property + bn-property {
          margin: 1em 0 0 0;
        }
      }
    `];
  }

  render() {
    return html`
      <add-new-import-modal
        .href="${this.href}"
        ?hide="${!this.showModal}"
        @close="${this._onModalClose}"
        import-show-path="${this.importShowPath}"
      ></add-new-import-modal>
      <div class="title-container">
        <h1>${this.title}</h1>
        ${renderIf(this.entity && this.entity.hasAction('create-import'), html`
          <button class="button button--contained" @click="${() => this.showModal = true}">
            <bn-icon name="fal fa-plus"></bn-icon> New Import
          </button>
        `)}
      </div>
      <div class="description">${this.description}</div>

      ${this._renderImportList()}
    `;
  }

  _renderImportList() {
    if (this.loading) {
      return html`<bn-loading></bn-loading>`;
    }
    const imports = this.imports || [];
    if (!imports.length) {
      return html`
        <div class="no-data">
          <p>There are no Imports to display.</p>
        </div>
      `;
    }
    return html`
      ${imports.map((item) => this._renderItem(item))}
      <bn-load-more-button
        .href="${this.href}"
        @moreloaded="${this._onMoreLoaded}"
      ></bn-load-more-button>
    `;
  }

  _renderItem(importObject) {
    const { name, state, recordCount, createdAt } = importObject.properties;
    return html`
      <bn-card .href="${this.importShowPath}?importId=${encodeURIComponent(importObject.getLink('self').href)}">
        <h3>${name}</h3>
        <div class="properties">
          <bn-property stacked label="State" class="state-property">${state}</bn-property>
          <bn-property stacked label="Record Count">${recordCount}</bn-property>
          <bn-property stacked label="Created">${this._formatDate(createdAt)}</bn-property>
        </div>
      </bn-card>
    `;
  }

  _onModalClose() {
    this.showModal = false;
    this._reload();
  }

  _reload() {
    entityStore.invalidateHref(this.href);
  }

  _formatDate(date) {
    return moment(date).format('MMMM D, YYYY h:mm a');
  }

  async _onMoreLoaded(e) {
    const { entity } = e.detail;
    this.imports = [...this.imports, ...entity.entities];
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    if (!this.entity) {
      return;
    }
    this.imports = this.entity.entities;
  }
}

customElements.define('import-list', ImportList);
